import { ICamera } from '@api/models/camera.model';
import { Button, Drawer, Input } from '@hyperflake/react-ui-library';
import { Label } from '@library/forms';
import { CircularProgress } from '@library/loaders/components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'httpConfig/http';
import { produce } from 'immer';
import { getResellerIdFromRedux } from 'modules/shared/helpers/shared.utils';
import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

interface ICameraConcludeConfirmationDrawer {
    open: boolean;
    onClose: () => void;
    camera: ICamera | null;
    onCameraUpdate?: (camera: ICamera) => void;
}

const CameraConcludeConfirmationDrawer = (props: ICameraConcludeConfirmationDrawer) => {
    const { onClose, camera, open, onCameraUpdate } = props;
    const [cameraName, setCameraName] = useState('');

    const { clientId, projectId } = useParams();
    const queryClient = useQueryClient();

    const concludeCameraMutation = useMutation(async (payload: any) => {
        const { data, status } = await http.put(
            `${
                import.meta.env.VITE_APP_API_URL
            }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/cameras/${payload.id}/conclude`
        );
        return { data, status };
    });
    const handleClose = () => {
        setCameraName('');
        onClose();
    };

    const handleConclude = async () => {
        if (camera === null) return onClose();
        try {
            const { data, status } = await concludeCameraMutation.mutateAsync({
                id: camera._id,
            });
            console.log({ data, status });
            toast.success(' TimeLapse Camera Is Concluding...');
            onCameraUpdate(data);
            // queryClient.setQueryData<ICamera[]>(['clients', clientId, 'projects', projectId, 'cameras'], (prev) => {
            //     if (!prev) return;

            //     const index = prev.findIndex((c) => c._id === camera._id);
            //     return produce(prev, (draft) => {
            //         draft.splice(index, 1);
            //         return draft;
            //     });
            // });
            handleClose();
        } catch (ex: any) {
            handleClose();
            console.log(ex.status);
            if (ex.status === 400) {
                toast.error(ex.data.message);
            } else {
                toast.error(ex?.data?.message || 'Some error occured, please try again.');
                console.log(ex);
            }
        }
    };

    return (
        <Drawer open={open} onClose={handleClose} title="Confirm Conclude">
            <div>
                <div>
                    <Label className="mt-2 inline-block">
                        To confirm conclude write:<span className="font-semibold">CONCLUDE</span>
                    </Label>
                    <Input
                        placeholder="Enter CONCLUDE"
                        // className="w-96 bg-white"
                        onChange={(e) => setCameraName(e.target.value)}
                        value={cameraName}
                    />

                    <div className="flex gap-2 mt-2">
                        <Button
                            disabled={concludeCameraMutation.isLoading}
                            onClick={() => onClose()}
                            variant="default"
                            color={'primary'}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={cameraName !== 'CONCLUDE'}
                            className="w-20"
                            onClick={() => handleConclude()}
                            variant="default"
                            color={'primary'}
                        >
                            {concludeCameraMutation.isLoading ? (
                                <CircularProgress size={18} color={'inherit'} />
                            ) : (
                                'Conclude'
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default CameraConcludeConfirmationDrawer;
